<template>
  <div class="c-route-details">
    <div class="c-route-details__start">
      <div class="c-route-details__start-time">15:39</div>
      <div>Ajuinlei 1, Gent</div>
    </div>
    <o-route-step
      type="walk"
      :trajectory="{
        label: 'Wandel naar Gent Zonnestraat.',
        duration: '1 min.'
      }"
    />
    <o-route-step
      type="tram"
      start="Gent Zonnestraat"
      end="Gent-Sint-Pietersstation"
      :trajectory="{
        number: '1',
        color: '#C23A00',
        label: 'Gent-Sint-Pietersstation',
        sublabel: '15:44 - halte 200025',
        duration: '17 min.'
      }"
    />
    <o-route-step
      type="train"
      start="Station Gent-Sint-Pieters"
      end="Station Antwerpen-Centraal"
      :trajectory="{
        number: 'IC',
        color: '#006FAC',
        label: 'Sint-Niklaas - Antwerpen',
        sublabel: '16:10 - spoor 6',
        duration: '45 min.'
      }"
    />
    <o-route-step
      type="bus"
      start="Antwerpen Astrid"
      end="Melkmarkt"
      :trajectory="{
        number: '10',
        color: '#789600',
        label: 'Melkmarkt',
        sublabel: '17:00 - halte 200021',
        duration: '13 min.'
      }"
    />
    <o-route-step
      type="walk"
      :trajectory="{
        label: 'Wandel naar Eiermarkt.',
        duration: '1 min.'
      }"
    />
    <div class="c-route-details__end">
      <div class="c-route-details__end-time">17:16</div>
      <div>Eiermarkt, Antwerpen</div>
    </div>
  </div>
</template>

<script>
import ORouteStep from '@/components/ORouteStep.vue'
export default {
  name: 'ORouteDetails',
  components: {
    ORouteStep
  }
}
</script>

<style lang="scss">
.c-route-details {
  padding: 1.6rem;

  .c-route-step + .c-route-step {
    margin-top: 1.2rem;
  }
}

.c-route-details__start,
.c-route-details__end {
  align-items: center;
  color: $blue-kbc-cement;
  display: flex;

  &:before {
    background: #FFF;
    border-radius: 1.2rem;
    color: $blue-kbc-dark;
    content: 'A';
    flex: none;
    font-size: 1.2rem;
    font-weight: 700;
    margin-right: 1.6rem;
    padding: 0.4rem 0;
    text-align: center;
    width: 2.4rem;
  }
}

.c-route-details__start {
  margin-bottom: 1.6rem;
}

.c-route-details__end {
  margin-top: 1.6rem;

  &:before {
    content: 'B'
  }
}

.c-route-details__start-time,
.c-route-details__end-time {
  color: $blue-kbc-dark;
  flex: none;
  font-weight: 600;
  margin-right: 1.6rem;
}
</style>
